<div #viewport class="app-container">
  <header mdcTopAppBar class="app-header" dense [viewport]="viewport" [fixedAdjust]="content" mdcElevation="6">
    <div mdcTopAppBarRow>
      <section mdcTopAppBarSection alignStart class="title-container">
        <img src="assets/images/caseflo.png" width="25" height="25" class="d-inline-block align-top" alt="" />
        <span mdcTopAppBarTitle>{{ applicationTitle }}</span>
      </section>
    </div>
  </header>

  <div #content class="content">
    <main class="main">
      <ng-content></ng-content>
    </main>
  </div>
</div>
